// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox-2bjXc","checkbox__mobile":"checkbox__mobile-36H0o","checkboxMobile":"checkbox__mobile-36H0o"};